import React from 'react'

const NoTableApp = React.createClass({

	getInitialState() {
		return {
			cart: this.props.flux.getStore('cartStore').getState()
		};
	},

	componentWillMount() {
		this.props.flux.getStore('cartStore').listen(this.handleCartChange)
	},

	componentWillUnmount() {
		this.props.flux.getStore('cartStore').unlisten(this.handleCartChange)
	},

	handleCartChange() {
		this.setState({cart: this.props.flux.getStore('cartStore').getState()})
	},

	handleClick(add) {
		add
			? this.props.flux.getActions('cartActions').addItem(this.props.productId)
			: this.props.flux.getActions('cartActions').removeItem(this.props.productId)
	},

	render() {
		let added = this.state.cart.items.filter((item) => item.productId == this.props.productId).length > 0
		return (
			<div>
				<button onClick={this.handleClick.bind(this, !added)} className="btn btn--small">
					{added ? 'Удалить из корзины' : 'Добавить в корзину'}
				</button>
			</div>
		)
	}

})

export default NoTableApp


/** WEBPACK FOOTER **
 ** ./src/scripts/components/NoTableApp.js
 **/